import React, { Component } from 'react';
import { FindTransactionId } from "../../api/index";
import Moment from 'react-moment';
import NumberFormat from 'react-number-format';

class Nota extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            data: null,
            date: null,
            isFetching: true,
            OrderInformation: null,
            listProduct: [],
            countdown: {
                days: 0,
                hours: 0,
                min: 0,
                sec: 0,
            },
            listStatusOrder: null,
            isPopUpOpen: false,
            tracking: null,
            isTracking: false
        }
    }

    fecthData() {
        const transactionId = this.props.match.params.id;
        const content = {
            transactionId: transactionId
        }

        FindTransactionId(content).then(res => {
            this.setState({
                data: {
                    subtotal: res[0].subtotal + res[0].kode_unik - res[0].value,
                    ongkir: res[0].value,
                    id: res[0].id,
                    berat: res[0].weight / 1000,
                    diskon: res[0].diskon,
                    total: res[0].subtotal,
                    kodeunik: res[0].kode_unik,
                    transactionId: res[0].invoiceNumber,
                    orderDate: res[0].createdAt,
                    status: res[0].StatusOrder.statusName,
                    courier: res[0].courier,
                    address: res[0].address,
                    shipTo: res[0].Address_Customer.shipTo,
                    phone: res[0].Address_Customer.phone,
                    createdAt: res[0].createdAt,
                    dateconfirm: res[0].dateconfirm,
                    dateproses: res[0].dateproses,
                    datesend: res[0].datesend,
                    datereceived: res[0].datereceived,
                    statusPosition: res[0].status - 1,
                    bank: {
                        bankname: res[0].Bank.bankname,
                        norek: res[0].Bank.norek,
                        image: res[0].Bank.logo,
                        an: res[0].Bank.an,
                    }
                },
                listProduct: res[0].OrderProducts,
                date: res[0].expireDate,
                isFetching: false,
                isLoading: false
            })
        }).catch(err => {
            console.log(err)
        })

    }

    componentDidMount() {
        this.fecthData();
    }

    render() {
        var { isLoading } = this.state;
        return (
            <>
                <style>
                    {`
                        @media print {
                            body, html, .invoice-wrapper { background-color: white !important; }
                            .no-print { display: none !important; }
                            .invoice-container { box-shadow: none !important; padding: 0 !important; margin: 0 !important; width: 100% !important; max-width: 100% !important;}
                        }
                    `}
                </style>

                {!isLoading ? (
                    <div className="invoice-wrapper" style={{ backgroundColor: '#f4f5f7', minHeight: '100vh', padding: '40px 20px', fontFamily: '"Nunito", "Segoe UI", Arial, sans-serif', color: '#333' }}>
                        <div className="invoice-container" style={{ maxWidth: '850px', margin: '0 auto', backgroundColor: '#fff', padding: '50px', borderRadius: '8px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' }}>
                            
                            {/* Tombol Cetak */}
                            <div className="no-print" onClick={() => window.print()} style={{ textAlign: 'right', marginBottom: '30px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px' }}>
                                <i className="fa fa-print" style={{ marginRight: '8px' }}></i> Cetak
                            </div>

                        {/* Header Nota */}
<div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px dashed #ccc', paddingBottom: '25px', marginBottom: '30px' }}>
    {/* Kiri (Logo & Info Penjual) */}
    <div style={{ width: '50%' }}>
        
        {/* DISINI: Ganti tag img lama dengan URL Cloudinary Anda */}
        <img 
            src="https://res.cloudinary.com/dhitaaaa/image/upload/v1741812951/logo-ipb-press_1_ewnxr0.jpg" 
            alt="IPB Press" 
            style={{ height: '55px', objectFit: 'contain', marginBottom: '20px' }} 
        />
        
        <div style={{ fontSize: '15px', marginBottom: '15px' }}>
            <span style={{ fontWeight: 'bold' }}>Nomor Nota : </span>
            <span style={{ color: '#140657', fontWeight: 'bold' }}>{this.state.data.transactionId}</span>
        </div>
        
        <div style={{ fontSize: '13px', color: '#555', marginBottom: '8px' }}>Diterbitkan atas nama:</div>
        
        <table style={{ fontSize: '13px' }}>
            <tbody>
                <tr>
                    <td style={{ fontWeight: 'bold', width: '80px', paddingBottom: '8px' }}>Penjual</td>
                    <td style={{ paddingBottom: '8px' }}>IPB Press</td>
                </tr>
                <tr>
                    <td style={{ fontWeight: 'bold', paddingBottom: '8px' }}>Tanggal</td>
                    <td style={{ paddingBottom: '8px' }}>
                        <Moment locale="id" format="LLLL">{this.state.data.orderDate}</Moment>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    {/* Kanan (Info Customer) */}
    <div style={{ width: '45%', paddingLeft: '20px', paddingTop: '10px' }}>
        <div style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '12px' }}>Nama Customer:</div>
        <div style={{ fontSize: '13px', lineHeight: '1.6' }}>
            <strong style={{ display: 'block', fontSize: '14px', marginBottom: '5px' }}>{this.state.data.shipTo}</strong>
            {this.state.data.address} <br />
            {this.state.data.phone}
        </div>
    </div>
</div>

                            {/* Tabel Produk */}
                            <div style={{ border: '1px dashed #ccc', borderRadius: '6px', overflow: 'hidden', marginBottom: '30px' }}>
                                <table width="100%" style={{ borderCollapse: 'collapse', fontSize: '14px' }}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#f9fafc', borderBottom: '1px dashed #ccc' }}>
                                            <th style={{ padding: '15px 20px', textAlign: 'left', width: '45%' }}>Nama Produk</th>
                                            <th style={{ padding: '15px 10px', textAlign: 'center' }}>Jumlah</th>
                                            <th style={{ padding: '15px 10px', textAlign: 'center' }}>Berat</th>
                                            <th style={{ padding: '15px 20px', textAlign: 'right' }}>Harga Barang</th>
                                            <th style={{ padding: '15px 20px', textAlign: 'right' }}>Sub Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.listProduct.map((value, index) => (
                                            <tr key={index}>
                                                <td style={{ padding: '20px', fontWeight: 'bold' }}>{value.Product.name}</td>
                                                <td style={{ padding: '20px 10px', textAlign: 'center' }}>{value.qty}</td>
                                                <td style={{ padding: '20px 10px', textAlign: 'center' }}>{value.weight} gr</td>
                                                <td style={{ padding: '20px', textAlign: 'right' }}>
                                                    <NumberFormat value={value.price} displayType={'text'} thousandSeparator={true} prefix={'Rp '} />
                                                </td>
                                                <td style={{ padding: '20px', textAlign: 'right' }}>
                                                    <NumberFormat value={value.price * value.qty} displayType={'text'} thousandSeparator={true} prefix={'Rp '} />
                                                </td>
                                            </tr>
                                        ))}
                                        {/* Subtotal Produk */}
                                        <tr style={{ borderTop: '1px solid #eaeaea' }}>
                                            <td colSpan="4" style={{ padding: '20px', fontWeight: 'bold', textAlign: 'right' }}>Subtotal Harga Produk</td>
                                            <td style={{ padding: '20px', textAlign: 'right', fontWeight: 'bold' }}>
                                                <NumberFormat value={this.state.data.subtotal} displayType={'text'} thousandSeparator={true} prefix={'Rp '} />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {/* Rekap Biaya (Ongkir, Kode Unik, Total) */}
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <div style={{ width: '45%' }}>
                                    
                                    {/* Ongkir */}
                                    <table width="100%" style={{ border: '1px dashed #ccc', borderRadius: '6px', marginBottom: '20px', fontSize: '13px', borderCollapse: 'collapse' }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ padding: '15px', color: '#555' }}>
                                                    {this.state.data.courier} (Berat: {this.state.data.berat} Kg)
                                                </td>
                                                <td style={{ padding: '15px', textAlign: 'right', color: '#555' }}>
                                                    <NumberFormat value={this.state.data.ongkir} displayType={'text'} thousandSeparator={true} prefix={'Rp '} />
                                                </td>
                                            </tr>
                                            <tr style={{ borderTop: '1px dashed #ccc' }}>
                                                <td style={{ padding: '15px', fontWeight: 'bold' }}>Subtotal Ongkos Kirim</td>
                                                <td style={{ padding: '15px', textAlign: 'right', fontWeight: 'bold' }}>
                                                    <NumberFormat value={this.state.data.ongkir} displayType={'text'} thousandSeparator={true} prefix={'Rp '} />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    {/* Biaya Lainnya */}
                                    <table width="100%" style={{ border: '1px dashed #ccc', borderRadius: '6px', marginBottom: '20px', fontSize: '13px', borderCollapse: 'collapse' }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ padding: '15px', color: '#555' }}>Kode Unik</td>
                                                <td style={{ padding: '15px', textAlign: 'right', color: '#555' }}>
                                                    - <NumberFormat value={this.state.data.kodeunik} displayType={'text'} thousandSeparator={true} prefix={'Rp '} />
                                                </td>
                                            </tr>
                                            <tr style={{ borderTop: '1px dashed #ccc' }}>
                                                <td style={{ padding: '15px', fontWeight: 'bold' }}>Subtotal Biaya Lainnya</td>
                                                <td style={{ padding: '15px', textAlign: 'right', fontWeight: 'bold' }}>
                                                    - <NumberFormat value={this.state.data.kodeunik} displayType={'text'} thousandSeparator={true} prefix={'Rp '} />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    {/* Total Pembayaran (Garis Solid) */}
                                    <table width="100%" style={{ border: '1px solid #333', borderRadius: '6px', fontSize: '15px', borderCollapse: 'collapse' }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ padding: '15px', fontWeight: 'bold' }}>Total Pembayaran</td>
                                                <td style={{ padding: '15px', textAlign: 'right', fontWeight: 'bold' }}>
                                                    <NumberFormat value={this.state.data.total} displayType={'text'} thousandSeparator={true} prefix={'Rp '} />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    
                                </div>
                            </div>

                        </div>
                    </div>
                ) : (
                    <div style={{
                        width: '100%',
                        height: '100vh',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: '#f4f5f7'
                    }}>
                        <h2>Menyiapkan Nota...</h2>
                    </div>
                )}
            </>
        )
    }
}

export default Nota;